/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-08T13:01:19.470Z by lizhutang (lizhutang@spolo.org)

'use strict'
import constVars from '../../bs4/consts'
const layerSelectorID = 'wwlayer-selector'

function resetLayerOptions (wwInst) {
  let Layers = wwInst.getLayers()
  wwjs.hyper.bind($(`#${layerSelectorID}`).get(0))`${window._.map(Layers, (value, key) => {
    if (key === constVars.mainLayerName) {
      return ''
    } else {
      return wwjs.hyper.wire(key)`<option value="${key}">${key}</option>`
    }
  }).join('')}`
}

function switchToLayer (wwInst, layerName, notStoreCurrent, ignoreLayerChk, SyncFlag) {
  if (!ignoreLayerChk && layerName === wwInst.currentLayer()) {
    return
  }
  let oldFlag = wwInst.setSyncFlag(SyncFlag || false)
  let afterStore = function (err) {
    if (!err) {
      wwInst.editor.runCommand('core:canvas-clear')
      wwInst.currentLayer(layerName)
      wwInst.editor.load(function (res) {
        // 如果重新加载了全部数据，则更新主选单的内容。
        if (SyncFlag) {
          resetLayerOptions(wwInst)
        }
        $(`#${layerSelectorID}`).val(layerName)
        if (layerName === constVars.mainLayerName) {
          $('.wwextracmd').css('display', 'none')
        } else {
          $('.wwextracmd').css('display', 'inline')
        }
        console.log('load res=', res)
        wwInst.setSyncFlag(oldFlag)
      })
    } else {
      wwInst.setSyncFlag(oldFlag)
      console.log('保存时发生错误:', err)
    }
  }
  if (notStoreCurrent) {
    afterStore(null)
  } else {
    wwInst.editor.store(afterStore)
  }
}

function createLayer (wwInst) {
  let Swal = window.Swal
  // console.log(`input from id(${self.inputId}):`, $(`#${self.inputId}`))
  // console.log('123', $(self.getInputEl()))
  // console.log(self)
  Swal.fire({
    title: '新层的名称',
    input: 'text',
    inputAttributes: {
      autocapitalize: 'off'
    },
    showCancelButton: true,
    confirmButtonText: '新建',
    cancelButtonText: '取消',
    // showLoaderOnConfirm: true,
    preConfirm: (name) => {
      if (wwInst.hasLayer(name) || name === '主页面') {
        Swal.showValidationMessage(
          `名为“${name}”的层已经存在，请更换名称`
        )
      } else {
        return name
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    // console.log(result)
    if (result.value) {
      var newOption = document.createElement('option')
      newOption.text = result.value
      newOption.value = result.value
      $(`#${layerSelectorID}`).append(newOption)
      switchToLayer(wwInst, result.value)
    } else if (typeof result.dismiss === 'string' && result.dismiss.length > 0) {
    }
  })
}

function removeLayer (wwInst) {
  let Swal = window.Swal
  let layerName = wwInst.currentLayer()
  if (layerName === constVars.mainLayerName) {
    return
  }
  Swal.fire({
    type: 'question',
    title: `<span>这将删除层<span style='color:red;'>${layerName}</span>，并且不可撤销，您确定么?</span>`,
    showCancelButton: true,
    confirmButtonText: '删除',
    cancelButtonText: '取消',
    // showLoaderOnConfirm: true,
    footer: '<a href>这不会自动删除引用本层的关联处，请手动修改</a>',
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    // console.log('result=', result)
    if (result.value) {
      $(`#${layerSelectorID} option:selected`).remove()
      switchToLayer(wwInst, constVars.mainLayerName, true)
      wwInst.removeLayer(layerName)
    } else if (typeof result.dismiss === 'string' && result.dismiss.length > 0) {
    }
  })
}

function renameLayer (wwInst) {
  let Swal = window.Swal
  // console.log(`input from id(${self.inputId}):`, $(`#${self.inputId}`))
  // console.log('123', $(self.getInputEl()))
  // console.log(self)
  let layerName = wwInst.currentLayer()
  if (layerName === constVars.mainLayerName) {
    return
  }
  Swal.fire({
    title: '修改层名称',
    input: 'text',
    footer: '<a href>这不会自动修改引用本层的关联处，请手动修改</a>',
    inputValue: layerName,
    inputAttributes: {
      autocapitalize: 'off'
    },
    showCancelButton: true,
    confirmButtonText: '修改',
    cancelButtonText: '取消',
    // showLoaderOnConfirm: true,
    onOpen: function () {
      var input = Swal.getInput()
      input.setSelectionRange(0, input.value.length)
    },
    preConfirm: (name) => {
      if (wwInst.hasLayer(name) || name === '主页面' || name === layerName) {
        Swal.showValidationMessage(
          `名为“${name}”的层已经存在，请更换名称`
        )
      } else {
        return name
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    // console.log(result)
    if (result.value) {
      let selectedOption = $(`#${layerSelectorID} option:selected`)
      selectedOption.attr('value', result.value)
      selectedOption.text(result.value)
      wwInst.renameLayer(layerName, result.value, false)
    } else if (typeof result.dismiss === 'string' && result.dismiss.length > 0) {
    }
  })
}

function setupLayer (wwInst) {
  $('.gjs-pn-commands').append($(`<div class="gjs-layer-info" style="margin:-${$('.gjs-pn-buttons').height() || 30}px;">
  <span id="wwlayer-create" style="margin-right:0px;padding-right:0px;" data-tooltip-pos="bottom" class="gjs-pn-btn fa fa-plus-square wwcmd" title="新建层" data-tooltip="新建层"></span>
  <div class="gjs-field" style="display:inline-block;"><div class="gjs-input-holder">
    <select id="${layerSelectorID}">
      <option value="${constVars.mainLayerName}" selected="selected">主页面</option>
    </select>
  </div></div>
  <span id="wwlayer-rename" style="display:none;margin-left:0px;padding-left:0px;" data-tooltip-pos="bottom" class="gjs-pn-btn fa fa-exchange wwcmd wwextracmd"  title="修改当前层名" data-tooltip="修改当前层名"></span>
  <span id="wwlayer-remove" style="display:none" data-tooltip-pos="bottom" class="gjs-pn-btn fa fa-minus-square wwcmd wwextracmd" data-tooltip="删除当前层" title="删除当前层"></span>
  </div>
  `))
  $('.gjs-pn-commands').on('click', '.wwcmd', function (evet) {
    switch (this.id) {
      case 'wwlayer-create':
        createLayer(wwInst)
        break
      case 'wwlayer-rename':
        renameLayer(wwInst)
        break
      case 'wwlayer-remove':
        removeLayer(wwInst)
        break
    }
    // console.log(this)
    // console.log(evet)
  })
  $(`#${layerSelectorID}`).change(function () {
    switchToLayer(wwInst, $(`#${layerSelectorID}`).val())
  })
}

export default {
  setup: setupLayer,
  switchTo: switchToLayer
}
